import { customFetch, appendFormDataWithObjectValues } from 'utils/http';
import { EmailAlreadyInUseError, HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { m8ErrorMessageMap } from 'services/production/utils/constants';

type Params = {
  idPartner: number;
  login: string;
};

export const updatePartnerLogin = async (params: Params): Promise<void> => {
  const body = new FormData();

  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(getM8AdminURL('updatePartnerLogin'), {
    method: 'PUT',
    body,
  });

  if (!response.ok) {
    if (response.status === 400) {
      const data = await response.json();

      if (data.message === m8ErrorMessageMap.EMAIL_ALREADY_IN_USE) {
        throw new EmailAlreadyInUseError();
      }
    }

    throw new HTTPResponseError(response);
  }
};
